import {$authHost, $host} from "./index";
import {API_ENDPOINTS, URLS} from "../utils/urls";


export type HistoryFilterParams = {
    limit?: number;
    offset?: number;
    userId?: number | string;
    companyId?: number | string;
    dateFrom?: string;
    dateTo?: string;
}

export type HistoryResponseData = {
    items: Array<any>;
    hasMore: boolean;
}

function buildQuery(params?: HistoryFilterParams): string {
    const query = new URLSearchParams();
    if (params) {
        if (params.limit !== undefined) query.append('limit', `${params.limit}`);
        if (params.offset !== undefined) query.append('offset', `${params.offset}`);
        if (params.userId) query.append('userId', `${params.userId}`);
        if (params.companyId) query.append('companyId', `${params.companyId}`);
        if (params.dateFrom) query.append('dateFrom', params.dateFrom);
        if (params.dateTo) query.append('dateTo', params.dateTo);
    }
    const str = query.toString();
    return str ? `?${str}` : '';
}


export async function actHistoryGetAPI(params?: HistoryFilterParams){
    try {
        return await $authHost.get(API_ENDPOINTS.ACT_HISTORY + buildQuery(params));

    } catch (error: any) {
        return error;
    }
}
